import { InnerBox } from "@/components/elements/InnerBox";
import { YEAR_MONTH_DAY_STR_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Stack, Box, Typography } from "@mui/material";
import dayjs from "dayjs";

type TTalentInternalMemoProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentInternalMemo: FCC<TTalentInternalMemoProps> = ({ defaultValues }) => {
  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            社内メモ
          </Typography>
        </Box>
      </Stack>

      {defaultValues?.internalMemo && (
        <Stack
          mt={3}
          p={2}
          sx={{
            backgroundColor: "#FFF9C4",
            borderRadius: rounded.sm,
            fontFamily: "inherit",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
          component="pre"
        >
          <Typography variant="body14" color={black[30]}>
            {defaultValues.internalMemo}
          </Typography>
        </Stack>
      )}

      <Stack direction="row" justifyContent="space-between">
        {defaultValues?.interviewDate && (
          <Typography variant="body14" color={black[70]} mt={1}>
            {defaultValues?.interviewDate && dayjs(defaultValues.interviewDate).isValid()
              ? `${dayjs(defaultValues.interviewDate).format(YEAR_MONTH_DAY_STR_FORMAT)} 実施`
              : EMPTY_STR.TEXT}
          </Typography>
        )}

        {defaultValues?.interviewer?.fullName && (
          <Typography variant="body14" color={black[70]} mt={1}>
            面談：{defaultValues?.interviewer?.fullName}
          </Typography>
        )}
      </Stack>
    </InnerBox>
  );
};
